// import * as Yup from "yup";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";

const element = document.getElementById("configDataDiv");
let baseUrl = element.getAttribute("data-baseurl");
if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-unused-vars
  baseUrl = process.env.REACT_APP_BACKEND_URL;
}
// export const BASE_URL = "http://172.27.204.235";
// export const BASE_URL = "https://40.121.213.121";

export const BASE_URL = baseUrl;

export const PERMISSIONS_KEY = "userPermissions";

export const CHECK_COOKIE = "checkCookie";

export const AUTHENTICATED_USER_COOKIE = "authenticatedUser";

export const SITE_STORAGE = localStorage;

export const sizeOfPage = {
  pageSize: 50,
};

// Date Picker Related constant
export const DATEPICKER_DATE_FORMAT = "MM/dd/yyyy";
export const DATEPICKER_CALENDAR_START_DAY = 1;
export const MMDDYYYY = "MM-DD-YYYY";
export const INVALID_DATE = "Invalid date";
export const ErrorMsg = "Something went wrong, please try after sometime.";

// Error Handler constant function
export const ErrorHandler = (error) => {
  return console.log("error", error);
};

// Error Handler constant function for network issues
export const NetworkErrorHandler = () => {
  return <div className="errorHandlerMsg"> !Oops, An error occurred!</div>;
};

// Error Handler constant function for network issues
export const ErrorCatchMsg = () => {
  return <div className="errorCatchMsg"> !Oops, An error occurred!</div>;
};

// Error Handler constant function for network issues
export const NoDataFound = () => {
  return (
    <div className="errorHandlerMsg">
      <div className="nfdICon">
        <FontAwesomeIcon icon={faFolderOpen} />
      </div>
      No Data Found
    </div>
  );
};

// Error Handler constant function for network issues
export const NoDataFoundComp = () => {
  return (
    <div className="noDataFoundComp">
      <div className="nfdICon">
        <FontAwesomeIcon icon={faFolderOpen} />
      </div>
      No Data Found
    </div>
  );
};

export const ApiError = () => {
  return { msg: ErrorMsg, type: "error" };
};

// Error Handler constant function for login api to return message response
export const ApiLoginMsgHandler = (response) => {
  if (response.data) {
    if (response.data.apiResponse !== null) {
      return { msg: "Login Successful", type: "success" };
    } else if (response.data.httpStatusCode === 401) {
      return {
        msg: "Incorrect email address or password. Please check and try again.",
        type: "error",
      };
    } else if (response.data.httpStatusCode === 500) {
      return { msg: ErrorMsg, type: "error" };
    }
  } else if (response.error) {
    return { msg: ErrorMsg, type: "error" };
  }
};

export const FooterContent = () => {
  return <span>© 2021 Viamedia. All Rights Reserved.</span>;
};

export const MainTitle = (props) => {
  return <div className="mainTitle">{props.title}</div>;
};

// Business Rule list for add new network
export const CommonBusinessRulesList = [
  {
    displayName: "Fill",
    ruleType: "SpotType",
    ruleValue: "Fill",
  },
  {
    displayName: "Bonus",
    ruleType: "SpotType",
    ruleValue: "Bnus",
  },
  {
    displayName: "Paid",
    ruleType: "SpotType",
    ruleValue: "Paid",
  },
];
